import request from '@/router/axios';



//deduction-page
export const deductionPage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/securityDeposit/deduction-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//deduction-amount
export const deductionAmount = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/securityDeposit/deduction-amount',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//return-securityDeposit
export const returnSecurityDeposit = (id) => {
    return request({
        url: '/api/blade-loanPost/securityDeposit/return-securityDeposit',
        method: 'get',
        params: {
            id,
        }
    })
}


//stock-page
export const stockPage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/securityDeposit/stock-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//stock-amount
export const stockAmount = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/securityDeposit/stock-amount',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//deduction-export
export const exportDeduction = (data) => {
    return request({
        url: `/api/blade-loanPost/securityDeposit/deduction-export`,
        method: "post",
        responseType: 'blob',
        data: data,
    });
}


//stock-export
export const exportStock = (data) => {
    return request({
        url: `/api/blade-loanPost/securityDeposit/stock-export`,
        method: "post",
        responseType: 'blob',
        data: data,
    });
}